export interface CarrierState { x: number; y: number; grounded: boolean; gripping: boolean }
export interface CarryResult { held: boolean; tilt: number; tension: number; dropReason?: 'grip'|'distance'|'tilt'|'impact' }

export const CARRY = { idealSpan: 92, maxSpan: 155, maxTilt: 0.62, impactDrop: 520 } as const;

export function evaluateCarry(a: CarrierState, b: CarrierState, previousHeld = false, impact = 0): CarryResult {
  if (!a.gripping || !b.gripping) return { held: false, tilt: 0, tension: 0, dropReason: previousHeld ? 'grip' : undefined };
  const dx = b.x - a.x; const dy = b.y - a.y; const span = Math.hypot(dx, dy);
  const tilt = Math.atan2(dy, Math.max(1, Math.abs(dx)));
  const tension = Math.max(0, Math.min(1, (span - CARRY.idealSpan) / (CARRY.maxSpan - CARRY.idealSpan)));
  if (impact > CARRY.impactDrop) return { held: false, tilt, tension, dropReason: 'impact' };
  if (span > CARRY.maxSpan) return { held: false, tilt, tension: 1, dropReason: 'distance' };
  if (Math.abs(tilt) > CARRY.maxTilt) return { held: false, tilt, tension, dropReason: 'tilt' };
  return { held: true, tilt, tension };
}
